import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';
// import {TOKEN_KEY} from '../utils/define';

const PublicRoute = ({children, ...rest}) => {
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    // const isAuthenticated = isLoggedIn || localStorage.getItem(TOKEN_KEY);

    return (
        <Route
            {...rest}
            render={({location}) =>
            isLoggedIn ? (
                    <Redirect
                        to={{
                            pathname: '/',
                            state: {from: location}
                        }}
                    />
                ) : (
                    children
                )
            }
        />
    );
};

export default PublicRoute;
